import { render, staticRenderFns } from "./RefundDetail.vue?vue&type=template&id=4a86b446&scoped=true&"
import script from "./RefundDetail.vue?vue&type=script&lang=js&"
export * from "./RefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a86b446",
  null
  
)

export default component.exports